import { createContext } from 'use-context-selector'
import { InviteBoxContextProps } from './types'
export const InviteBoxContext = createContext({} as InviteBoxContextProps)
